export default __webpack_public_path__ + "static/media/altoperu.b415272e.JPG";